var map = {
	"./bg/strings.json": 1812,
	"./cs/strings.json": 1813,
	"./da/strings.json": 1814,
	"./de/strings.json": 1815,
	"./el/strings.json": 1816,
	"./es-ES/strings.json": 1817,
	"./es-LA/strings.json": 1818,
	"./et/strings.json": 1819,
	"./fi/strings.json": 1820,
	"./fr-CA/strings.json": 1821,
	"./fr/strings.json": 1822,
	"./it/strings.json": 1823,
	"./lt/strings.json": 1824,
	"./lv/strings.json": 1825,
	"./nl/strings.json": 1826,
	"./no/strings.json": 1827,
	"./pl/strings.json": 1828,
	"./pseudo/strings.json": 1829,
	"./pt/strings.json": 1830,
	"./ro/strings.json": 1831,
	"./sk/strings.json": 1832,
	"./sl/strings.json": 1833,
	"./sv/strings.json": 1834,
	"./zh-CN/strings.json": 1835,
	"./zh-TW/strings.json": 1836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1811;